import { render } from "./humanityFiveMuseumEdit.vue?vue&type=template&id=4ae301f4&scoped=true"
import script from "./humanityFiveMuseumEdit.vue?vue&type=script&lang=js"
export * from "./humanityFiveMuseumEdit.vue?vue&type=script&lang=js"

import "./humanityFiveMuseumEdit.vue?vue&type=style&index=0&id=4ae301f4&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae301f4"]])

export default __exports__